export default __webpack_public_path__ + "static/media/gold-9.999a495e.png";